import React, { useContext } from 'react';
import { RotatingLines } from 'react-loader-spinner';
import { LoadingContext } from './LoadingContext';
import './GlobalSpinner.css';

const GlobalSpinner = () => {
    const { isLoading } = useContext(LoadingContext);

    if (!isLoading) return null;

    return (
        <div className="spinner-overlay">
            <RotatingLines
                visible={true}
                height="96"
                width="96"
                color="#0147C8"
                strokeColor="#0147C8"
                strokeWidth="3"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
            />
        </div>
    );
};

export default GlobalSpinner;